<script setup lang="ts">
const count = defineModel({ type: Number, required: true })
</script>

<template>
  <div class="flex flex-nowrap">
    <button
      class="flex h-10 w-10 items-center justify-center border-2 border-neutral-200 hover:bg-neutral-100 2xl:h-12 2xl:w-12"
      @click="
        () => {
          if (count > 1) {
            count--
          }
        }
      "
    >
      <Icon name="fa6-solid:minus" class="h-4 2xl:h-6" />
    </button>
    <div
      class="flex h-10 items-center border-y-2 border-neutral-200 px-5 2xl:h-12 2xl:px-8 2xl:text-lg"
    >
      <span class="font-pragmatica-ext whitespace-nowrap font-bold">
        {{ count + ' ' + $t('configurator.pieces') }}
      </span>
    </div>
    <button
      @click="count++"
      class="flex h-10 w-10 items-center justify-center border-2 border-neutral-200 hover:bg-neutral-100 2xl:h-12 2xl:w-12"
    >
      <Icon name="fa6-solid:plus" class="h-4 2xl:h-6" />
    </button>
  </div>
</template>
